import {Component, OnDestroy, OnInit} from '@angular/core';
import {SubSink} from "@Common/core/utils/subsink";
import {UserConfig} from "app/dar/common/services/user-config/user-config.model";
import {UserConfigService} from "app/dar/common/services/user-config/user-config.service";
import {Individu, IndividuService} from "@Common/core/services";
import {combineLatest} from "rxjs";
import {ManageRoleDarService} from "app/dar/common/services/roles/manage-roles.service";

@Component({
  selector: 'app-config-notif',
  templateUrl: './config-notif.component.html',
  styleUrls: ['./config-notif.component.scss']
})
export class ConfigNotifComponent implements OnInit, OnDestroy {
  subSink = new SubSink();
  config: UserConfig;
  individu: Individu;
  hasRoleFonctionnel = false;
  constructor(private userCfgSvc: UserConfigService,
              private individuSvc: IndividuService,
              private roleSvc: ManageRoleDarService) { }


  ngOnInit(): void {
    const observable = combineLatest([
      this.individuSvc.individu$,
      this.userCfgSvc.getUserCfg()
    ]);
    this.subSink.sink = observable.subscribe(
      (res) => {
        this._init_ind_cfg(res[0], res[1])
      }
    )
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

  updateCfg() {
    this.userCfgSvc.patch(this.config).subscribe()
  }

  _init_ind_cfg(individu, config) {
    this.individu = individu;
    this.config = config;
    this.hasRoleFonctionnel = this.roleSvc.hasRoleFonctionnel(individu)

    this.config.config.notif_demandeur = config.config?.notif_demandeur ?? true;
    this.config.config.notif_contact = config.config?.notif_contact ?? false;

    this.config.config.notif_change_value = config.config?.notif_change_value ?? this.hasRoleFonctionnel;
    this.config.config.notif_change_step = config.config?.notif_change_step ?? this.hasRoleFonctionnel;
    this.config.config.notif_comment = config.config?.notif_comment ?? this.hasRoleFonctionnel;
    console.log('config init: ', this.config);
  }
}
